import { MarketingLayout } from "../../components/marketing/marketing-layout";
import { aboutContent } from "../../content/marketing/about";
import { usePageMeta } from "../../hooks/use-page-meta";

export default function AboutPage() {
  usePageMeta(aboutContent.metaTitle, aboutContent.metaDescription);

  return (
    <MarketingLayout>
      <section className="mx-auto flex max-w-[65ch] flex-col gap-4 px-4 py-16 md:px-6 md:py-24">
        <h1 className="font-bold font-display text-3xl md:text-4xl">
          {aboutContent.heading}
        </h1>
        {aboutContent.body.map((paragraph) => (
          <p className="text-base leading-relaxed" key={paragraph.slice(0, 32)}>
            {paragraph}
          </p>
        ))}
      </section>
    </MarketingLayout>
  );
}
